// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Cj","innerTile":"Dj","heading":"Ej","instaTileBtn":"Fj","disabled":"Gj","instaTileElement":"Hj","instagramPic":"Ij"};